__turbopack_context__.v({
  "pill": "Pill-module__PpcZva__pill",
  "pillAccent": "Pill-module__PpcZva__pillAccent",
  "pillCaution": "Pill-module__PpcZva__pillCaution",
  "pillCopyable": "Pill-module__PpcZva__pillCopyable",
  "pillDanger": "Pill-module__PpcZva__pillDanger",
  "pillDark": "Pill-module__PpcZva__pillDark",
  "pillDefault": "Pill-module__PpcZva__pillDefault",
  "pillEllipsis": "Pill-module__PpcZva__pillEllipsis",
  "pillIconOnly": "Pill-module__PpcZva__pillIconOnly",
  "pillInfo": "Pill-module__PpcZva__pillInfo",
  "pillLarge": "Pill-module__PpcZva__pillLarge",
  "pillNormal": "Pill-module__PpcZva__pillNormal",
  "pillRound": "Pill-module__PpcZva__pillRound",
  "pillSecondary": "Pill-module__PpcZva__pillSecondary",
  "pillSmall": "Pill-module__PpcZva__pillSmall",
  "pillSuccess": "Pill-module__PpcZva__pillSuccess",
});
